<template>
  <div id="app" class="relative w-screen h-screen">
    <NavBar/>

    <Hero/>
    <AboutUs/>
    <Services/>
    <ContactForm/>
  </div>
</template>

<script>
  import AboutUs from './AboutUs';
  import ContactForm from './ContactForm';
  import Hero from './Hero';
  import NavBar from '../../components/NavBar';
  import Services from './Services';

  import '../../assets/css/base.css';
  import '../../assets/css/index/index.css';

  export default {
    name: 'Index',
    components: {
      AboutUs,
      ContactForm,
      Hero: Hero,
      NavBar: NavBar,
      Services,
    }
  };
</script>
